module.exports = __webpack_public_path__ + "static/media/image3.383e75dd.jpeg";